import React, { useEffect, useState } from "react";
//import "./init-map-data.scss";
import OpenlayerMapView from "../../../components/open-layer/open-layer";
import * as InitMapStore from "../../../redux/store/init-map/init-map.store";
import * as appActions from "../../../core/app.store";
import * as GidStore from "../../../redux/store/project-management/gid.store";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FunctionButton from "../../init-map-data/function-button/function-button";
import LeftControlView from "../../init-map-data/left-control/left-control"
function InitMapDataView(props) {
    const { showLoading, point, setPoint, polygon } = props;
    const [extend, setExtend] = useState([]);
    const [zoom, setZoom] = useState();
    const [mapLayer, setMapLayer] = useState();
    const [dataItems, setDataItem] = useState();
    const [isFist, setIsFist] = useState(false);
    const [show, setShow] = useState(false);
    const [projectModel, setProjectModel] = useState()
    const [coordinate, setCoordinate] = useState();
    const [gid, setGid] = useState()
    const [tableName, setTableName] = useState()

    useEffect(() => {
        console.log("voos", mapLayer);
        if (props.planningId) {
            if (props.mapId) {
                props.GetMapDetailById(props.mapId, props.planningId);
                setShow(true);
            }
            else props.UpdateDefaultMapData(props.planningId);
        } else props.GetMapDetailById(21, 1);
        props.GetAllBaseMapDefault();
        setMapLayer(undefined);
        setDataItem(undefined);
    }, []);

    useEffect(() => {
        if (isFist) {
            setDataItem(undefined);
        }
        setIsFist(true);
    }, [props.layers]);

    const handleGetDataClick = (value) => {
        console.log("value", value);
        setDataItem(undefined);
        setDataItem(value);
    };

    useEffect(() => {
        if (dataItems) {
            // GetListProject(parseInt(dataItems.gid), dataItems.table)
            setGid(dataItems.gid);
            setTableName(dataItems.table)
        } else return;
    }, [dataItems]);

    return (
        <div
            className="init-map-data-container h-100 container-fluid p-0"
            style={{ overflowX: "hidden" }}
        >
            <div className="h-100 p-0 m-0">
                    {props.initMap.hasLoadingData && (
                        <OpenlayerMapView
                            setExtend={setExtend}
                            setZoom={setZoom}
                            setMapLayer={setMapLayer}
                        />
                    )}
                
            </div>
            <div>
                {mapLayer && (
                    <FunctionButton
                        key={Date.now.toString()}
                        mapLayer={mapLayer}
                        planningName={props.planningName}
                        handleGetDataClick={handleGetDataClick}
                        isLisence={true}
                        point={point}
                        setPoint={setPoint}
                        polygon={polygon}
                        polygonCoords = {props.polygonCoords}
                    />
                )}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    initMap: state.initMap,
    layers: state.initMap.layers,
    isLoading: state.app.loading,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            GetMapDetailById: InitMapStore.GetMapDetailById,
            GetAllBaseMapDefault: InitMapStore.GetAllBaseMap,
            UpdateDefaultMapData: InitMapStore.UpdateDefaultMapData,
            showLoading: appActions.ShowLoading,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InitMapDataView);
